import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export interface ErrorCardData {
  message: string;
}

@Component({
    selector: 'app-error-card',
    templateUrl: './error-card.component.html',
    styleUrls: ['./error-card.component.scss'],
    standalone: false
})
export class ErrorCardComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ErrorCardComponent>, @Inject(MAT_DIALOG_DATA) public data: ErrorCardData) { }

  ngOnInit() {
  }

  public closeMe() {
    this.dialogRef.close();
  }

}
